import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "error"]

  preview() {
    this.clearError()
    this.previewTarget.innerHTML = ''
    const files = this.inputTarget.files

    if (files.length > 5) {
      this.showError('Maximum 5 photos allowed')
      this.inputTarget.value = ''
      return
    }

    // Validate file sizes (max 10MB each)
    for (const file of files) {
      if (file.size > 10 * 1024 * 1024) {
        this.showError(`${file.name} is too large. Maximum size is 10MB.`)
        this.inputTarget.value = ''
        return
      }
    }

    Array.from(files).forEach((file, index) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const container = document.createElement('div')
        container.className = 'relative group'

        const img = document.createElement('img')
        img.src = e.target.result
        img.className = 'w-full h-16 object-cover rounded border border-gray-200'
        img.alt = `Photo ${index + 1}`

        const removeBtn = document.createElement('button')
        removeBtn.type = 'button'
        removeBtn.className = 'absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity'
        removeBtn.innerHTML = '&times;'
        removeBtn.onclick = () => this.removePhoto(index)

        container.appendChild(img)
        container.appendChild(removeBtn)
        this.previewTarget.appendChild(container)
      }
      reader.readAsDataURL(file)
    })
  }

  removePhoto(indexToRemove) {
    const dt = new DataTransfer()
    const files = this.inputTarget.files

    for (let i = 0; i < files.length; i++) {
      if (i !== indexToRemove) {
        dt.items.add(files[i])
      }
    }

    this.inputTarget.files = dt.files
    this.preview()
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove('hidden')
    } else if (window.showToast) {
      window.showToast(message, 'error')
    } else {
      alert(message)
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ''
      this.errorTarget.classList.add('hidden')
    }
  }
}
